<script>
  export let checked;
</script>

<label class="relative inline-block w-24 h-8 cursor-pointer select-none">
  <input
    type="checkbox"
    class="sr-only peer"
    bind:checked={checked}
  />

  <div
    class="w-full h-full rounded-full flex items-center justify-between px-3 text-sm font-semibold transition-all
           bg-transparent border border-[var(--app-primary-color)] text-[var(--app-primary-color)]
           peer-checked:bg-[var(--app-primary-color)] peer-checked:text-white">

    <span class={checked ? 'opacity-100' : 'opacity-0'}>ON</span>
    <span class={checked ? 'opacity-0' : 'opacity-100'}>OFF</span>
  </div>

  <div
    class="absolute top-1 left-1 w-6 h-6 rounded-full bg-white shadow-md flex items-center justify-center text-gray-500 transition-transform
           peer-checked:translate-x-[64px]">
    {#if checked}
      <!--<svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>-->
      <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    {:else}
      <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    {/if}
  </div>
</label>